export function getWeekRange(range = [], full = true) {
  const DEFAULT_RANGE = 52;
  const getOption = (value) => ({
    value,
    text: full ? `${value} semanas` : String(value),
  });

  if (!range.length) {
    return Array.from(Array(DEFAULT_RANGE))
      .map((_, value) => !!value && getOption(++value))
      .filter((item) => item);
  }

  return range.map((value) => getOption(value));
}
